import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendances/_layout/settings/')({
  beforeLoad: () => {
    throw redirect({
      to: '/attendances/settings/attendance-books'
    });
  }
});